import React from 'react'
// graphql
import { COMPANY_DETAILS_QUERY } from 'graphql/company/queries'
// hooks
import { useApolloClient, useCurrentUser } from 'hooks/index'
// types
import { CompanySubscriptionLevel, ICompany } from 'types/graphql'
// utils
import get from 'lodash/get'
import { parseGraphQLErrorMessages } from 'utils/errors/parsers'

export const useCompanySubscriptionLevel = (companyId = null) => {
  const [company, setCompany] = React.useState<ICompany>()
  const [companySubscriptionLevel, setCompanySubscriptionLevel] = React.useState<string>()

  const user = useCurrentUser()

  const { client } = useApolloClient()

  const setCurrentCompany = async () => {
    try {
      const currentCompany = get(
        await client.query({
          query: COMPANY_DETAILS_QUERY,
          variables: {
            filter: {
              id: companyId
            }
          }
        }),
        'data.companies.data[0]'
      )

      setCompany(currentCompany)
    } catch (e) {
      console.log('[useCompanySubscriptionLevel.setCurrentCompany]', parseGraphQLErrorMessages(e))
    }
  }

  React.useEffect(() => {
    if (companyId) {
      setCurrentCompany()
    }
  }, [companyId])

  React.useEffect(() => {
    if (company) {
      const level = get(company, 'licences[0].subscriptionLevel', CompanySubscriptionLevel.Standard)

      return setCompanySubscriptionLevel(level)
    }
    const level = get(user, 'company.licences[0].subscriptionLevel', CompanySubscriptionLevel.Standard)

    return setCompanySubscriptionLevel(level)
  }, [company])

  return companySubscriptionLevel
}
